module.exports = __webpack_public_path__ + "img/29_2.4db05913.png";